'use client';

import { Button } from '@/components/ui/button';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';
import { Users } from 'lucide-react';
import Image from './Image';

interface RoomCardProps {
    reservable: App.Data.RoomData | App.Data.TableData;
    onReserve: () => void;
}

export function RoomCard({ reservable, onReserve }: RoomCardProps) {
    return (
        <Card className="flex flex-col overflow-hidden pt-0">
            <Image
                src={reservable.image}
                alt={reservable.name}
                placeholder={reservable.placeholder}
                className="object-cover"
            />

            <CardHeader>
                <CardTitle>{reservable.name}</CardTitle>
                <CardDescription className="flex items-center gap-1">
                    <Users className="h-4 w-4" />
                    <span>Capacity: {reservable.capacity} people</span>
                </CardDescription>
            </CardHeader>
            <CardContent className="flex-1">
                <p className="text-sm text-muted-foreground">
                    {reservable.description}
                </p>
            </CardContent>
            <CardFooter>
                <Button onClick={onReserve} className="w-full">
                    Reserve
                </Button>
            </CardFooter>
        </Card>
    );
}
